import React from 'react';
import { observer } from 'mobx-react';

import Page from 'components/Page';
import LocationMap from 'components/LocationMap';

import { useDataStore } from 'state/DataStore';

const LocationTemplate = observer(({ page: { acf: { home_position, home_pin, default_category, styles } } }) => {
    const dataStore = useDataStore();
    
    let { locations = [], location_categories = [] } = dataStore.data;
    
    const apiKey = dataStore.getSetting('general_settings', 'google_maps_api_key');
    
    // need slice to convert observableArrays to regular arrays
    locations = locations.slice();
    location_categories = location_categories.slice();
    
    const home = {
        position: home_position,
        icon:     home_pin,
    };

    const mapStyles = (() => {
        try {
            return JSON.parse(styles);
        } catch (error) {
            console.error('Error parsing map styles:', error);
            return undefined;
        }
    })();
    
    return (
        <Page>
            {home.position && (
                <LocationMap
                    locations={locations}
                    categories={location_categories}
                    defaultCategory={default_category}
                    center={home.position}
                    home={home}
                    apiKey={apiKey}
                    options={mapStyles ? { styles: mapStyles } : {}}
                />
            )}
        </Page>
    );
});

export default LocationTemplate;
